/**
 * @generated SignedSource<<40aea8c95a45ac5c315f569b1462451e>>
 * @relayHash 116d7dd98106004f89c2ff5db718aa1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 027c06c8bb448735fa76296a78b57e7381016654e70826af5c253b4cf66e4476

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { hubHomeContentWrapperQuery } from './hubHomeContentWrapperQuery.graphql';

const node: PreloadableConcreteRequest<hubHomeContentWrapperQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "027c06c8bb448735fa76296a78b57e7381016654e70826af5c253b4cf66e4476",
    "metadata": {},
    "name": "hubHomeContentWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
